import {
    GET_LIST_CUSTOMER_CARE_CATEGORY,
    GET_SPECIFIC_CUSTOMER_CARE_CATEGORY,
    UPDATE_SPECIFIC_CUSTOMER_CARE_CATEGORY,
    CREATE_NEW_CUSTOMER_CARE_CATEGORY,
    REMOVE_CUSTOMER_CARE_CATEGORY,
    GET_CUSTOMER_CARE_CATEGORY_ACTIVE
} from '@/redux/actions/types';

/**
 * initial state cho module Customer Care Category
 */
const INIT_STATE = {
    customerCareCategoryList: [],
    currentCustomerCareCategory: null,
    customerCareCategoryActiveList: [],
    pagination: {
        currentPage: 1,
        total: 0,
        perPage: 30
    }
};

export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case GET_LIST_CUSTOMER_CARE_CATEGORY: {
            return {
                ...state,
                customerCareCategoryList: action.payload?.data || [],
                pagination: {
                    currentPage: parseInt(action.payload.current_page),
                    total: parseInt(action.payload.total),
                    perPage: parseInt(action.payload.per_page),
                }
            };
        }

        case GET_CUSTOMER_CARE_CATEGORY_ACTIVE: {
            return {
                ...state,
                customerCareCategoryActiveList: action.payload?.data || [],
            };
        }

        case GET_SPECIFIC_CUSTOMER_CARE_CATEGORY: {
            return { ...state, currentCustomerCareCategory: action.payload };
        }

        case CREATE_NEW_CUSTOMER_CARE_CATEGORY: {
            return {
                ...state,
                customerCareCategoryList: [action.payload, ...state.customerCareCategoryList],
                customerCareCategoryActiveList: [action.payload, ...state.customerCareCategoryActiveList],
                pagination: {
                    ...state.pagination,
                    total: state.pagination.total + 1
                }
            };
        }

        case UPDATE_SPECIFIC_CUSTOMER_CARE_CATEGORY: {
            const updatedList = state.customerCareCategoryList.map(item =>
                item.id === action.payload.id ? action.payload : item
            );

            const updatedActiveList = state.customerCareCategoryActiveList.map(item =>
                item.id === action.payload.id ? action.payload : item
            );

            return {
                ...state,
                customerCareCategoryList: updatedList,
                customerCareCategoryActiveList: updatedActiveList
            };
        }

        case REMOVE_CUSTOMER_CARE_CATEGORY: {
            const filteredList = state.customerCareCategoryList.filter(
                item => !action.payload.includes(item.id)
            );

            const filteredActiveList = state.customerCareCategoryActiveList.filter(
                item => !action.payload.includes(item.id)
            );

            return {
                ...state,
                customerCareCategoryList: filteredList,
                customerCareCategoryActiveList: filteredActiveList
            };
        }

        default:
            return { ...state };
    }
};
